import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function Signup(){  
  const [name,setName] = useState("");
  const [email,setEmail] = useState("");
  const [password,setPassword] = useState("");
  const navigate = useNavigate();

  useEffect(() => { 
    const userId = localStorage.getItem("userId"); 
    if (userId) navigate(`/dashboard/${userId}`); 
  }, [navigate]);
  
  const handleSignup = async () => {
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/auth/signup`, { name, email, password });
      navigate("/");
    } catch (err) {
      alert("Signup failed");
    }
  };

  return (
    <div className="container">
      <div className="card" style={{maxWidth:520, margin:"36px auto"}}>
        <h2>Create account</h2>
        <p className="small">Start creating interview flows</p>
        <input className="input" placeholder="Full name" onChange={e=>setName(e.target.value)} />
        <input className="input" placeholder="Email" onChange={e=>setEmail(e.target.value)} style={{marginTop:10}} />
        <input className="input" type="password" placeholder="Password" onChange={e=>setPassword(e.target.value)} style={{marginTop:10}} />
        <div style={{display:"flex",gap:8,marginTop:12}}>
          <button className="btn" onClick={handleSignup}>Sign up</button>
        </div>
      </div>
    </div>
  );
}
